<div class="mi-grid-component mi-grid-padding">
  <div class="search-and-export-data-panel">
    <label *ngIf="!bottomSearchBar" for="searchId" class="mb-2" translate>{{inputPlaceholder}}</label>
    <input *ngIf="!bottomSearchBar" id="searchId" type="text" class="grid-search-bar top" [(ngModel)]="search"
      (keyup)="onQuickFilterChanged($event, dt)" [placeholder]="inputPlaceholder" />
    <div class="export-data-panel">
      <span class="export-button top" *ngIf="!bottomExportButton && (exportUrl !== '') && totalRecords > 0">
        <button class="header-action-btn export" (click)="exportGridExcel($event)"
          [attr.aria-label]="'aria_label_download_excel' | translate" title="Download Excel">
          XLS
          <i class="fa fa-fw fa-file-excel-o" aria-hidden="true"></i>
        </button>
      </span>

      <span class="export-button top" *ngIf="!bottomExportButton && (printUrl !== '') && totalRecords > 0">
        <button class="header-action-btn export" (click)="exportGridPdf($event)"
          [attr.aria-label]="'aria_label_download_pdf' | translate" title="Download Pdf">
          PDF
          <i class="fa fa-fw fa-file-pdf-o" aria-hidden="true"></i>
        </button>
      </span>
    </div>
  </div>

  <p-table #dt [ngClass]="isDetailScreen ? 'detail-screen-available' : ''" [lazy]="true" [rows]="paginationPageSize"
    [metaKeySelection]="true" [value]="datasource" [paginator]="pagination" [totalRecords]="totalRecords"
    (onLazyLoad)="loadDatasourceLazy($event)" [selectionMode]="rowSelection" (onRowSelect)="onRowSelect($event)"
    (onRowUnselect)="onRowUnselect($event)" [(selection)]="selectedRecords" [resizableColumns]="enableResizer"
    [first]="first">

    <ng-template pTemplate="header">
      <tr>
        <ng-container *ngFor="let col of columnDefs; let colId=index">
          <th *ngIf="col.resize && enableResizer" [ngClass]="col?.class ? col.class : ''" pResizableColumn
            [pSortableColumn]="(col?.sort) ? col.sortId: ''" [width]="col?.width"
            [attr.aria-label]="'aria_label_table_header_with_parameter' | translate: { name: col.header }"
            title="{{col.header}}" id="th{{colId}}">
            <p-sortIcon *ngIf="col?.sort" [field]="col.sortId"></p-sortIcon>
            {{col.header}}
          </th>

          <th *ngIf="!col.resize" [ngClass]="col?.class ? col.class : ''"
            [pSortableColumn]="(col?.sort) ? col.sortId: ''"
            [attr.aria-label]="'aria_label_table_header_with_parameter' | translate: { name: col.header }"
            title="{{col.header}}">
            <p-sortIcon *ngIf="col?.sort" [field]="col.sortId"></p-sortIcon>
            {{col.header}}
          </th>
        </ng-container>

        <th tabindex="0" class="action-column" *ngIf="actionButtonsDefs.length"
          [attr.aria-label]="'aria_label_table_header_with_parameter' | translate: { name: 'label_action' | translate }"
          [title]="'label_action' | translate" [width]="actionButtonWidth">
          {{ 'label_action' | translate }}
        </th>

      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td tabindex="0" class="grid-align-center" *ngIf="actionButtonsDefs.length === 0"
          [attr.colspan]="columnDefs.length" headers='th0'>
          {{ 'label_no_records_found' | translate }}
        </td>
        <td tabindex="0" class="grid-align-center" *ngIf="actionButtonsDefs.length > 0"
          [attr.colspan]="columnDefs.length + 1" headers='th0'>
          {{ 'label_no_records_found' | translate }}
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columnDefs" let-rowIndex="rowIndex">
      <!-- Note: [pSelectableRow]="rowData" [pSelectableRowIndex]="rowIndex" were removed from tr below to avoid row selection. -->
      <tr>
        <td tabindex="0"
          [attr.aria-label]=" col.field + ' ' + (rowData[col.field] ? checkType(rowData[col.field])?'Edit field':rowData[col.field] : 'Edit field')"
          *ngFor="let col of columnDefs" [ngClass]="col?.class ? col.class : ''">
          <div title="{{rowData[col.field]}}" style="-webkit-box-orient: vertical;" *ngIf="col.inputType === 'noInput'">
            {{rowData[col.field]}}</div>

          <label style="font-size: 0" *ngIf="col.inputType === 'autoComplete'" for="{{col.model}}{{rowIndex}}"
            translate>{{col.model}}{{rowIndex}}</label>
          <p-autoComplete [dropdown]="true" *ngIf="col.inputType === 'autoComplete'" #autoComplete
            class="autocomplete" optionLabel="key" optionValue="value" [(ngModel)]="rowData[col.model]" inputId="{{col.model}}{{rowIndex}}"
            (onSelect)="onSelect($event,col.keyId,rowData, col.model, autoComplete)"
            [suggestions]="suggestion" (completeMethod)="filter($event,col.suggestion)"
            (onClear)="onClear(col.keyId,rowData)" [size]="30" [minLength]="0" [placeholder]="rowData[col.placeholder]"
            [forceSelection]="true" [autoHighlight]="true" appendTo="body">
            <ng-template let-suggestionData pTemplate="item">
              <div class="autocomplete-list-item">
                {{ suggestionData.key }}
              </div>
            </ng-template>
          </p-autoComplete>
          <label style="font-size: 0" *ngIf="col.inputType === 'autoComplete'" for="{{col.model}}{{rowIndex}}"
            translate>{{col.model}}{{rowIndex}}</label>
          <p-autoComplete [dropdown]="true" [dropdownMode]="current" *ngIf="col.inputType === 'multiAutoComplete'" #multiAutoComplete
            class="autocomplete-multi" field="key" [(ngModel)]="rowData[col.model]" inputId="{{col.model}}{{rowIndex}}"
            (onSelect)="onSelectMulti($event,col.keyId,rowData)" (onUnselect)="onRemove($event,col.keyId,rowData)" 
            [suggestions]="suggestion" (completeMethod)="filter($event,col.suggestion)"
            (onClear)="onClear(col.keyId,rowData)" [size]="30" [minLength]="0" [placeholder]="rowData[col.placeholder]"
            [forceSelection]="true" [autoHighlight]="true" [multiple]="true">
            <ng-template let-suggestionData pTemplate="item">
              <div class="autocomplete-list-item">
                {{ suggestionData.key }}
              </div>
            </ng-template>
          </p-autoComplete>
          <label style="font-size: 0" for="fareinput{{rowIndex}}" *ngIf="col.inputType === 'input'"
            translate>fareinput{{rowIndex}}</label>
          <input type="text" id="fareinput{{rowIndex}}" *ngIf="col.inputType === 'input'" [(ngModel)]='input' />
        </td>
        <td class="grid-action-buttons" *ngIf="actionButtonsDefs.length">
          <div class="grid-action">
            <div *ngFor="let btn of actionButtonsDefs">
              <button class="btn-action" *ngIf="rowData[btn.field]" (click)="actionBtnClick($event, rowData, btn.class)"
                [attr.aria-label]="rowData[btn.ariaLabel]" innerHTML="{{rowData[btn.field]}}">
              </button>
            </div>
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="paginatorright" let-state>
      Total records: {{state.totalRecords}}
    </ng-template>
  </p-table>
</div>